import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useThemeMode } from '../../ThemeContext';
import { APP_URLS } from '../../helpers/url_helper';

// Import assets for DemoTrail section
import SecureIcon from '../../assets/icon-secure.svg';
import AiIcon from '../../assets/icon-ai.svg';
import TeamsIcon from '../../assets/icon-teams.svg';
import Bg1 from '../../assets/hero-bg-1.png';
import Bg2 from '../../assets/hero-bg-2.png';
import Bg3 from '../../assets/hero-bg-3.png';

// Import dark theme images
import DarkDashboard from '../../assets/landing_page_images/Dark-Dashboard.jpg';
import DarkChat from '../../assets/landing_page_images/Dark-Chat.jpg';
import DarkDocument from '../../assets/landing_page_images/Dark-Document.jpg';

// Import light theme images
import LightDashboard from '../../assets/landing_page_images/Light-Dashboard.png';
import LightChat from '../../assets/landing_page_images/Light-Chat.png';
import LightDocument from '../../assets/landing_page_images/Light-Document.png';

function DemoTrail() {
  const { mode } = useThemeMode();

  return (
    <>
      {/* Hero Section */}
      <section className="py-5 bg-white position-relative hero-bg-pattern">
        <Container className="text-center py-5">
          <Row className="justify-content-center mb-4">
            <Col xs={12}>
              <div className="hero-strip d-flex flex-wrap justify-content-center gap-3 mb-4">
                <div className="hero-strip-item">
                  <img src={SecureIcon} alt="Secure" className="hero-strip-icon img-fluid" />
                  <div className="hero-strip-label">Secure & Encrypted</div>
                </div>
                <div className="hero-strip-item">
                  <img src={AiIcon} alt="AI" className="hero-strip-icon img-fluid" />
                  <div className="hero-strip-label">AI-Powered Platform</div>
                </div>
                <div className="hero-strip-item">
                  <img src={TeamsIcon} alt="Teams" className="hero-strip-icon img-fluid" />
                  <div className="hero-strip-label">Used by Teams</div>
                </div>
              </div>
              <h1 className="section-title">Fast, Effective, Measurable Compliance.</h1>
              <p className="section-subtitle mx-auto" style={{ maxWidth: '700px' }}>Complimate makes compliance simple. Draft policies, procedures, and required documents in minutes, run real-time audits, and get instant answers pulled from your files — measurable, effective, and regulator-ready.</p>
              <div className="d-flex gap-3 justify-content-center mb-4 flex-wrap">
                <Button as={Link} to={APP_URLS.SIGNUP} variant="primary" className="btn-teal">Get started</Button>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center hero-images-row">
            <Col xs={12} md={4} className="mb-3 mb-md-0">
              <div className="rounded-4 overflow-hidden shadow-sm w-100 hero-image-container" style={{ 
                backgroundImage: `url(${mode === 'dark' ? DarkDashboard : LightDashboard})`, 
                height: '280px' 
              }}></div>
            </Col>
            <Col xs={12} md={4} className="mb-3 mb-md-0">
              <div className="rounded-4 overflow-hidden shadow-sm w-100 hero-image-container" style={{ 
                backgroundImage: `url(${mode === 'dark' ? DarkChat : LightChat})`, 
                height: '280px' 
              }}></div>
            </Col>
            <Col xs={12} md={4}>
              <div className="rounded-4 overflow-hidden shadow-sm w-100 hero-image-container" style={{ 
                backgroundImage: `url(${mode === 'dark' ? DarkDocument : LightDocument})`, 
                height: '280px' 
              }}></div>
            </Col>
          </Row>
        </Container>
      </section>


    </>
  );
}

export default DemoTrail;
